import { Box, Skeleton, Stack, Typography } from "@mui/material";
import type { AmountDto } from "Infrastructure/Api/Api";
import type { CurrencyCode } from "Models/CurrencyCodes";
import { formatCurrency } from "Utils/CurrencyUtils";

type Props = {
  amounts: Array<AmountDto>;
  emptyStateCurrency?: CurrencyCode;
  isLoading?: boolean;
  title: string;
  colorVariant?: "success" | "warning" | "error";
};

export const BaseTransactionFees = ({
  amounts,
  emptyStateCurrency,
  isLoading,
  title,
  colorVariant = "success",
}: Props) => {
  // The API returns one entry per currency; amounts must never be summed across
  // currencies, so each entry renders as its own row.
  const displayAmounts: Array<{ value: number; currencyCode?: string }> =
    amounts.length > 0
      ? amounts
      : [{ value: 0, currencyCode: emptyStateCurrency }];

  return (
    <Stack>
      <Typography
        textTransform="uppercase"
        fontSize="1rem"
        fontWeight="600"
        gutterBottom
      >
        {title}
      </Typography>
      {isLoading ? (
        <Box display="flex" gap={2} alignItems="baseline">
          <Typography variant="h4" color={colorVariant}>
            <Skeleton width={140} />
          </Typography>
        </Box>
      ) : (
        displayAmounts.map(({ value, currencyCode }) => (
          <Box
            key={currencyCode ?? "unknown"}
            display="flex"
            gap={2}
            alignItems="baseline"
          >
            <Typography variant="h4" color={colorVariant}>
              {formatCurrency({
                amount: value,
                currencyCode,
                maxDecimalPlaces: 2,
              })}
            </Typography>
          </Box>
        ))
      )}
    </Stack>
  );
};
